import { useRef } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { InstructionEditor } from '@/features/instructions/components/editor/InstructionEditor'

/**
 * Каждый переход на «новую статью» — чистый редактор, даже если он уже открыт: адрес тот же,
 * и без смены ключа «плюс» в меню оставлял на экране прежний текст. Переход «новая → созданная»
 * ключ не меняет: редактор переживает создание статьи (`useSeedAcrossCreate`).
 */
export const InstructionEdit = () => {
  const { slug } = useParams<{ slug?: string }>()
  const location = useLocation()
  const session = useRef(location.key)
  if (!slug) session.current = location.key
  return <InstructionEditor key={session.current} />
}
